import { bankStatementConstants } from '../constants';

const initialState = {
  loading: false,
  records: []
}

export function bankStatement(state = initialState, action) {
  switch (action.type) {
    case bankStatementConstants.GET_REQUEST:
      return {
        loading: true,
        records: [],
      };
    case bankStatementConstants.GET_SUCCESS:
      console.log(action.payload);
      return {
        loading: false,
        records: action.payload,
      };
    case bankStatementConstants.GET_FAILURE:
      return {
        loading: false,
        error: action.error,
        records: [],
      };
    default:
      return state
  }
}
